import styled from 'styled-components/macro';

/**
 * ScreenReaderOnly
 * refer to https://tailwindcss.com/docs/screen-readers for screen reader only styles
 */
export const ScreenReaderOnly = styled.span`
  position: absolute;
  /* stylelint-disable unit-allowed-list */
  width: 1px;
  height: 1px;
  margin: -1px;
  /* stylelint-enable unit-allowed-list */
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;
